import {isUndefined} from 'lodash';

import {findPanelSequence} from '../../../services/panels';
import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../services/tracking';
import {ThunkAction} from '../../appThunk';
import {CellsContext} from '../cells/context/cellsContext';
import {setPanelAction} from '../panelsActions';
import {makeGetAppPanelIdFromPanel} from '../panelsSelectors';
import {makeMessagePanelId, NewPanelId, PanelTypesEnum} from '../panelStateBase';
import {MessageViewerPanelState} from './messageViewerPanelState';

interface PopoutMessageViewerOptions {
  cellsContext?: CellsContext;
  initialHeight?: number;
}

export function popoutMessageViewerAction(
  panelId: NewPanelId,
  messageUid: string,
  options: PopoutMessageViewerOptions = {},
): ThunkAction {
  return (dispatch, getState) => {
    const state = getState();
    const message = state.data.messages[messageUid];
    if (isUndefined(message)) {
      throw new Error(`Cannot retrieve message view in popout, messageUid = ${messageUid}`);
    }

    const popupPanelId = makeMessagePanelId();
    const popupAppPanelId = makeGetAppPanelIdFromPanel()(state, {panelId});
    const {conversationId} = message;
    const viewerPanelState: MessageViewerPanelState = {
      id: popupPanelId,
      type: PanelTypesEnum.MESSAGE,
      sequence: findPanelSequence(),
      cellsContext: options.cellsContext,
      conversationId,
      messageUid,
      popupAppPanelId,
      shouldForcePopout: true,
      initialHeight: options.initialHeight,
    };
    dispatch(setPanelAction(viewerPanelState));

    trackInterfaceEvent(InterfaceEventsEnum.POPOUT_MESSAGE);
  };
}
